export default __webpack_public_path__ + "static/media/fa-brands-400.329a95a9.woff";